import { Component, Inject, OnInit } from '@angular/core';
import { TransactionModel } from './partners.model';
import { PartnersService } from './partners.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { PartnersListComponent } from './partners-list.component';
import { BankAccountModel } from '../../../finanzas/bancos/bankaccount.model';
import { BankAccountService } from '../../../finanzas/bancos/bankaccount.service'
import { consts } from '../../../../consts';
import { Utils } from '../../../../shared/utils';
import { Efectivo } from '../../../../models/finanzas/efectivo/efectivo.model';
import { EfectivoService } from '../../../../services/finanzas/efectivo/efectivo.service';
import { Option } from '../../../../shared/models/option.model';

@Component({
    selector: 'app-partners-form-transactions',
    templateUrl: './partners-form-transactions.component.html',
    styleUrls: ['./partners-form-transactions.component.css'],
    standalone: false
})
export class PartnersFormTransactionsComponent implements OnInit {
  public partnerSelected = this.data['PartnerSelected'];
  public isContribution: boolean = this.data.isContribution;
  public transactionModel: TransactionModel = new TransactionModel();
  public depositSaved: boolean = false;
  public ready: boolean = false;
  public paided: boolean = false;
  public isEditMode: boolean = false;
  public list: boolean = false;

  public billMethods = [
    consts.TYPEPAY_CASH,
    consts.TYPEPAY_BANKTRANSFERENCE
  ];

  public bankAccounts: BankAccountModel[] = [];
  public dataSource: TransactionModel[] = [];
  public headerTable: any[] = [
    { field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString()}`, class: (row) => `` },
    { field: 'description', title: 'Descripción', cell: (row) => row.description ? row.description : '', class: (row) => `` },
    { field: 'amount', title: 'Cantidad', cell: (row) => `${row.amount}  `, class: (row) => `` },
    { field: 'typePay', title: 'Método de pago', cell: (row) => row.typePay ? `${row.typePay}` : '', class: (row) => `` },
    { field: 'bankAccountInfo', title: 'Efectivo / Banco', cell: (row) => row.bankAccountInfo ? `${row.bankAccountInfo}` : '', class: (row) => `` },
    { field: 'transactionType', title: 'Tipo de transacción', cell: (row) => `${row.transactionType ? 'Aportación' : 'Devolución'}  `, class: (row) => '' },
    { field: 'accountingModels', title: 'Cuenta Contable', cell: (row) => `${row.accountingModels}`, class: (row) => '' }
  ];

  public invalidDate: boolean = false;
  public invalidAmount: boolean = false;
  public invalidTypePay: boolean = false;
  public invalidAccountNumber: boolean = false;
  public invalidBankAccount: boolean = false;
  public invalidDescription: boolean = false;
  public invalidPaymentCard: boolean = false;

  public efectivoList: Efectivo[] = [];

  public get typePayOptions(): Option[] {
    return this.billMethods.map(method => ({ label: method, value: method }));
  }

  public get efectivoOptions(): Option[] {
    return this.efectivoList.map(item => ({ label: item.nombre, value: item.uid }));
  }

  public get bankAccountOptions(): Option[] {
    return this.bankAccounts.map(item => ({ label: `${item.bank} - ${item.iban}`, value: item.uid }));
  }

  constructor(
    public dialogRef: MatDialogRef<PartnersListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public partnersService: PartnersService,
    public bankAccountService: BankAccountService,
    private efectivoService: EfectivoService,
  ) { }

  ngOnInit(): void {

    this.efectivoService.list()
      .then(listadoEfectivos => {
        this.efectivoList = listadoEfectivos
      });

    this.bankAccountService.getList()
      .then(bankAccounts => {
        this.bankAccounts = bankAccounts.list;
        this.ready = true;
      });
    this.getData();
  }

  onChangeAccount() {

  }

  public pay(): void {
    this.transactionModel.partnerId = this.data.uid;

    let noError: boolean = true;

    // Validations
    if (this.transactionModel.date == null) {
      noError = false;
      this.invalidDate = true;
    }

    if (this.transactionModel.accountingModelsId == null) {
      noError = false;
      this.invalidAccountNumber = true;
    }

    if (this.transactionModel.amount == null || this.transactionModel.amount < 0) {
      noError = false;
      this.invalidAmount = true;
    }

    if (this.transactionModel.typePay == null) {
      noError = false;
      this.invalidTypePay = true;
    }

    if (this.transactionModel.description == null || this.transactionModel.description == '') {
      noError = false;
      this.invalidDescription = true;
    }

    if (this.transactionModel.typePay === consts.TYPEPAY_BANKTRANSFERENCE) {

      if (this.transactionModel.bankAccountsUid == null) {
        noError = false;
        this.invalidBankAccount = true;
      }
    }

    if (this.transactionModel.typePay === consts.TYPEPAY_CASH) {
      this.transactionModel.commissions = 0;
      this.transactionModel.bankAccountsUid = consts.EMPTY_GUID;
    }

    if (this.transactionModel.typePay !== "Efectivo") {
      this.transactionModel.efectivoId = null;
    }

    this.transactionModel.commissions = Number(this.transactionModel.commissions);

    // Request
    if (noError) {
      if (this.isEditMode === false) {
        this.partnersService.partnersTransactionCreate(this.transactionModel)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al añadir el pago");
          });
      }
      if (this.isEditMode === true) {
        this.partnersService.partnersTransactionUpdate(this.transactionModel)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al actualizar el pago");
          });
      }
    } else {
      this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
    }
  }

  public getData(): void {
    this.depositSaved = false;
    this.ready = false;
    this.paided = false;
    this.invalidDate = false;
    this.invalidAmount = false;
    this.invalidTypePay = false;
    this.invalidBankAccount = false;
    this.invalidDescription = false;
    this.invalidPaymentCard = false;


    // Asignamos si es devolucion o no
    this.transactionModel.transactionType = this.data.isContribution;

    this.partnersService.partnersTransactionList(this.data.uid)
      .then(response => {
        this.dataSource = response;

        if (this.dataSource.length > 0) {
          this.list = true;
        }

        this.ready = true;
      })
      .catch(error => {
        this.ready = true;
      });
  }

  public allocateRemaining(): void {
    if (this.isEditMode) {
      this.transactionModel.amount = Utils.GetValueWithDecimals((this.dataSource.find(f => f.uid == this.transactionModel.uid).amount));
    }
  }

  public delete(uidParticipationDeposit: number): void {
    this.partnersService.partnersTransactionDelete(uidParticipationDeposit)
      .then(response => {
        this.getData();
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error al eliminar el pago");
      });
  }

  public edit(uidParticipationDeposit: number): void {
    this.paided = false;
    this.isEditMode = true;
    this.depositSaved = false;

    this.transactionModel = this.dataSource.find(item => item.uid === uidParticipationDeposit);
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public trackByIndex(i: number) { return i; }

}
